module.exports = require("date-fns/isDate");